import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Link } from 'react-router-dom';
import {
  FormAlert,
  FormGroup,
  NewInputText,
  parseFinalFormErrors,
} from '@saucelabs/sl-component-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import Button from '@saucelabs/sl-component-buttons';
import validate from '@saucelabs/sl-util-validate';
import { CURRENT_DC } from '@saucelabs/sl-util-config';

import Styles from './LoginForm.styles';

const constraints = {
  username: {
    presence: { allowEmpty: false },
  },
  password: {
    presence: { allowEmpty: false },
  },
  data_center: {
    presence: { allowEmpty: false },
  },
};

const LoginForm = ({ initialValues, loginUser, nextQueryParam }) => (
  <Form
    initialValues={initialValues}
    onSubmit={(values) => (
      loginUser({ ...values, nextQueryParam })
        // react-final-form requires forms to resolve with no value on success
        .then(() => null)
        .catch(({ response }) => {
          parseFinalFormErrors(
            {},
            response.data.error?.message,
          );
        })
    )}
    render={({ form, handleSubmit }) => {
      const { error, submitError, submitting } = form.getState();

      return (
        <form onSubmit={handleSubmit}>
          <FormAlert type="danger">{error || submitError}</FormAlert>
          <Row>
            <Col xs>
              <Field
                autoFocus
                className="form-control"
                component={NewInputText}
                name="username"
                placeholder="Username or email address"
                type="text"
              />
            </Col>
          </Row>
          <Row>
            <Col
              className={Styles['form-group-password']}
              xs
            >
              <Field
                className="form-control"
                component={NewInputText}
                name="password"
                placeholder="Password"
                type="password"
              />
              <Link
                className={Styles['forgot-link']}
                tabIndex="-1"
                to="/send-password-reset"
              >
                Forgot?
              </Link>
            </Col>
          </Row>

          <FormGroup>
            <Row middle="xs">
              <Col xs={5} />
              <Col xs={7}>
                <Button
                  block
                  category="action"
                  className={Styles['submit-button']}
                  disabled={submitting}
                  id="submit"
                  type="submit"
                  withArrow
                >
                  Sign In
                </Button>
              </Col>
            </Row>
          </FormGroup>
        </form>
      );
    }}
    validate={(values) => validate(values, constraints, { format: 'grouped' })}
  />
);

LoginForm.propTypes = {
  initialValues: PropTypes.shape({
    data_center: PropTypes.string,
  }).isRequired,
  loginUser: PropTypes.func.isRequired,
  nextQueryParam: PropTypes.string.isRequired,
};

const mapStateToProps = () => ({
  initialValues: {
    data_center: CURRENT_DC,
  },
});

const LoginFormWrapperContainer = connect(mapStateToProps)(LoginForm);

export default LoginFormWrapperContainer;
export { LoginForm, mapStateToProps };
